<template>
  <div class="joinUs">
    <header-wrapper></header-wrapper>
    <!--    <header-wrapper></header-wrapper>-->
    <div class="banner">
      <p>伯乐寻才，职等你来</p>
    </div>
    <div class="post">
      <div class="contentTitle postTitle">
        <p class="name">招聘岗位</p>
        <p class="desc">JOB VACANCY</p>
      </div>
      <div class="postList animate__fadeInUp animate__animated">
        <ul>
          <li>
            <p>设计类</p>
            <a href="https://www.zhipin.com/gongsir/7c16e5ba65f5b45b1nd509q4EVI~_120000.html?ka=position-2" target="_blank">了解更多</a>
          </li>
          <li>
            <p>技术类</p>
            <a href="https://www.zhipin.com/gongsir/7c16e5ba65f5b45b1nd509q4EVI~_100000.html?ka=position-3" target="_blank">了解更多</a>
          </li>
          <li>
            <p>产品类</p>
            <a href="https://www.zhipin.com/gongsir/7c16e5ba65f5b45b1nd509q4EVI~_110000.html?ka=position-4" target="_blank">了解更多</a>
          </li>
          <li>
            <p>市场类</p>
            <a href="https://www.zhipin.com/gongsir/7c16e5ba65f5b45b1nd509q4EVI~_140000.html?ka=position-5" target="_blank">了解更多</a>
          </li>
          <li>
            <p>运营类</p>
            <a href="https://www.zhipin.com/gongsir/7c16e5ba65f5b45b1nd509q4EVI~_130000.html?ka=position-6" target="_blank">了解更多</a>
          </li>
          <li>
            <p>风控类</p>
            <a href="https://www.zhipin.com/gongsir/7c16e5ba65f5b45b1nd509q4EVI~_180000.html?ka=position-7" target="_blank">了解更多</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="welfare">
      <div class="contentTitle welfareTitle">
        <p class="name">员工福利</p>
        <p class="desc">EMPLOYEE WELFARE</p>
      </div>
      <img src="../../assets/img/welfareContent.png" alt="" class="welfareContent">
    </div>
    <footer-wrapper></footer-wrapper>
  </div>
</template>

<script>
import headerWrapper from '@/components/header'
import footerWrapper from '@/components/footer'

export default {
  name: 'JoinUs',
  components: { headerWrapper, footerWrapper },
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.joinUs{
  background: #F6F6F6;
  .banner{
    background:url("../../assets/img/joinUsBanner.png") no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 196px;
    padding-top: 88px;
    p{
      font-size: 96px;
      //font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
    }
  }
  .post{
    height: 1078px;
    .postTitle{
      padding-top: 114px;
    }
    .postList{
      width: 1585px;
      margin: 91px auto 0 auto;
      ul{
        li{
          width: 459px;
          height: 298px;
          background: #FFFFFF;
          border-radius: 24px;
          text-align: center;
          margin-bottom: 58px;
          margin-right: 102px;
          display: inline-block;
          &:last-child{
            margin-right: 0px;
          }
          &:nth-child(3){
            margin-right: 0px;
          }
          p{
            font-size: 48px;
            //font-family: 'Microsoft YaHei';
            font-weight: 400;
            color: #333333;
            margin-bottom: 36px;
            padding-top: 86px;
          }
          a {
            width: 240px;
            height: 48px;
            line-height: 48px;
            background: #FEA643;
            border-radius: 24px;
            font-size: 18px;
            //font-family: 'Microsoft YaHei';
            font-weight: 400;
            color: #FFFFFF;
            display: inline-block;
            text-align: center;
            &:hover{
              background: #FFCA76;
            }
          }
        }
      }
    }
  }
  .welfare{
    height: 1528px;
    background: #FFFFFF;
    .welfareTitle{
      padding-top: 102px;
    }
    .welfareContent{
      width: 1462px;
      margin:62px auto 0 auto;
      display: block;
    }
  }
}

</style>